export const AVATARS = [
    {
        id: 'novice_adventurer',
        name: 'Novice Adventurer',
        levelReq: 1,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Felix'
    },
    {
        id: 'studious_scholar',
        name: 'Studious Scholar',
        levelReq: 2,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Aneka'
    },
    {
        id: 'brave_warrior',
        name: 'Brave Warrior',
        levelReq: 5,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Brian'
    },
    {
        id: 'mystic_mage',
        name: 'Mystic Mage',
        levelReq: 8,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Eliza'
    },
    {
        id: 'tech_explorer',
        name: 'Tech Explorer',
        levelReq: 10,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Christian'
    },
    {
        id: 'master_mind',
        name: 'Master Mind',
        levelReq: 15,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Aretha'
    },
    {
        id: 'legendary_hero',
        name: 'Legendary Hero',
        levelReq: 20,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Alexander'
    },
    {
        id: 'cosmic_guardian',
        name: 'Cosmic Guardian',
        levelReq: 30,
        style: 'adventurer',
        url: 'https://api.dicebear.com/9.x/adventurer/svg?seed=Yolanda'
    }
];

export const getAvatarUrl = (seed) => `https://api.dicebear.com/9.x/adventurer/svg?seed=${seed}`;
